<div class="card">
  <h2>{{username}}</h2>
  <hr />
  <p class="label">{{heading}}</p>

  <div class="radio-group">
    @for (unit of businessUnits; track unit.business_unit.id) {
      <label>
        <input
          type="radio"
          name="businessUnit"
          [value]="unit.business_unit.id"
          [(ngModel)]="selectedUnit"
        />
        {{ unit.business_unit.name }}
      </label>
    }
  </div>

  <button class="proceed-button bg-primary border-[1px] border-none text-white font-[2px] text-[1rem] rounded-3xl mx-[1%] shadow-0 cursor-pointer focus:ring focus:ring-violet-300" (click)="onProceed()">PROCEED</button>
</div>
